import React from "react";
import BasePage from "../../base/BasePage";
import { Layout, Loader} from "nq-component";
import HomePage from "../Homepage/HomePage.js";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { getAllSchemasUseCase } from "../../usecases/schema/";
import MainPagePresenter from "./MainPagePresenter";
import withRouter from "../../withRouter";
import { Routes, Route } from "react-router-dom";
import NotFoundPage from "../notfound";


class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route, item);
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="min-vh-100 d-flex justify-content-center align-items-center ">
          <Loader />
        </div>
      );
    }
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/users" element={<HomePage />} />
          <Route path="*" element={<NotFoundPage />} />
          {/* <Route path="/about" element={<AboutUsPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/contact" element={<ContactPage />} /> */}
        </Routes>
        {/* </main> */}
      </Layout>
    );
  }
}

export default withRouter(MainPage);
